import { AfterViewInit, Component, OnInit, Renderer2, Inject } from '@angular/core';
import { CONFIGURATION } from '@environments/app.constants';
import { ApiService } from '@services/api.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { BehaviorSubject } from 'rxjs';
import { DataHelper } from '@helpers/data.helper';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizationService } from '@services/localization.service';
import { TranslatePipe } from '@pipes/translate.pipe';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { avsconfig_online, avsconfig_shop } from '@environments/environment';

declare let window;

@Component({
  selector: 'document-upload-component',
  templateUrl: '../sharedTemplates/document-upload.component.html',
})
export class DocumentUpload implements OnInit, AfterViewInit {
  title: string;
  uploadDoc: UntypedFormGroup;
  uploadDocRaw: any;
  input_filepath = '';
  input_isdisabled = '';
  fileCaseControl: any;

  file;
  hasInsicToken = false;

  constructor(
    public _UiHelper: UiHelper,
    private _ApiService: ApiService,
    private _DataHelper: DataHelper,
    public _Router: Router,
    private _ActivatedRoute: ActivatedRoute,
    private _LocalizationService: LocalizationService,
    public _LZ: LocalizationService,
    private _FormBuilder: UntypedFormBuilder,
    private _UserHelper: UserHelper,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document
  ) {
    this.uploadDoc = _FormBuilder.group({
      DocumentTypeCombo: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
    });
  }

  ngOnInit() {
    this.uploadDoc.valueChanges.subscribe(x => {
      this.uploadDocRaw = x;
    });

    this.getToken();
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('Personal_Documents', false);
    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();

    this.caseControl();
  }

  upload(files) {
    this._ApiService.UploadtoAWS(files[0], 'customer/' + this._UserHelper.customerUser.CustomerId).then(result => {
      if (result.code == 'error') {
        this._UiHelper.errorSnackBar(result.message, '');
      } else if (result.code == 'success') {
        this.input_filepath = result.message;
        this.input_isdisabled = 'disabled';
      }
    });
    this.caseControl();
  }

  sendCloudFiles() {
    const translator = new TranslatePipe(this._LocalizationService);
    this._ApiService.cloudFiles(this.uploadDocRaw, this.input_filepath).then(result => {
      const t_message = translator.transform('upload_successful', null);
      this._UiHelper.successSnackBar(t_message, '');
      this.uploadDoc.reset();
      this.file = null;
      this.caseControl();
    });
  }

  caseControl() {
    this._ApiService.getUploadFilesControl().then(x => {
      this.fileCaseControl =
        x &&
        x.map(item => {
          if (item.CreateDate != undefined) {
            const createDate = item.CreateDate.split('-');
            if (createDate.length > 0) item.CreateDate = new Date(createDate[2], createDate[1], createDate[0]);
          }

          return item;
        });
      ////console.log("X", x);
    });
  }
  s;
  getToken() {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService.getInsicToken().then(result => {
      //this._UiHelper.setLoadingDialog(false);
      //console.warn("INSIC TOKEN",result);
      if (result != '') {
        this.hasInsicToken = true;
        if (this._UserHelper.customerUser.BranchId == avsconfig_online.onlineBranchId) {
          //console.warn(avsconfig_online.resourceUrl);
          window.__AVS_CONFIG__ = {
            apiUrl: avsconfig_online.apiUrl,
            resourceUrl: avsconfig_online.resourceUrl,
            partnerId: avsconfig_online.partnerId,
            token: result,
            startRoute: '/login',
            registrationType: 'simple',
            lang: this._LocalizationService.LANGCODE,
          };
        } else {
          window.__AVS_CONFIG__ = {
            apiUrl: avsconfig_shop.apiUrl,
            resourceUrl: avsconfig_shop.resourceUrl,
            partnerId: avsconfig_shop.partnerId,
            token: result,
            startRoute: '/login',
            registrationType: 'simple',
            lang: this._LocalizationService.LANGCODE,
          };
        }
        this.s = this.renderer2.createElement('script');
        this.s.type = 'text/javascript';
        this.s.src = avsconfig_online.resourceUrl + 'static/js/avs-loader.min.js';
        this.s.text = ``;
        this.renderer2.appendChild(this._document.body, this.s);
      }
    });
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    try {
      if (this.s && window.AVS_UNMOUNT()) {
        window.AVS_UNMOUNT();
      }
    } catch (error) {
      console.log('error');
    }
  }
}
